namespace advisorop.components.common {

    class SelectCuAdvisorController {
        onAdvisorSelected: any;
        selectedAdvisor: domains.IAdvisor;
        advisor: domains.IAdvisor;
        isAdvisorFormVisible: boolean = false;
        label: string;
        labelColWidth: number = 2;
        clearAfterSelect: string = "true";
        //noResults: boolean;
        user: domains.identity.IUser;
        currentAdvisor: domains.IAdvisor;

        static $inject = ["advisorService", "identityService"];
        constructor(public advisorService: services.AdvisorService, private identityService: services.IdentityService) {
        }

        $onInit(): void {
            //this.noResults = true;
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.currentAdvisor = this.user.advisor;
            })
            this.isAdvisorFormVisible = false;
        };

        $routerOnActivate(next, previous) {
        };

        //.filter((v) => { return v.id != this.currentAdvisor.id; });
        //return all advisors except current advisor who searching this..
        search(searchTerm: string): ng.IPromise<{}> {
            return this.advisorService.searchAdvisors(searchTerm).then((response) => {
                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            var adv: domains.IAdvisor = {};
            angular.copy(this.selectedAdvisor, adv);
            //clear only if clear property is set
            if (this.clearAfterSelect === "true")
                this.resetSearch();
            this.onAdvisorSelected({ advisor: adv });
        };

        resetSearch(): void {
            this.selectedAdvisor = null;
            this.advisor = null;
            this.isAdvisorFormVisible = false;
            //this.noResults = true;
        };

        advisorCreated(advisor: domains.IAdvisor): void {
            var adv: domains.IAdvisor = {};
            angular.copy(advisor, adv);
            this.resetSearch();
            this.onAdvisorSelected({ advisor: adv });
        };
    }



    class SelectCuAdvisor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onAdvisorSelected: "&",
                selectedAdvisor: "=",
                advisor: "@",
                label: "@",
                labelColWidth: "@",
                clearAfterSelect: "@"
            };
            this.controller = SelectCuAdvisorController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/select-cu-advisor.html';
        }
    }
    angular.module(Constants.APP).component("selectCuAdvisor", new SelectCuAdvisor());


}